// src/components/projects/ProjectKanban.jsx - Simplified to use unified components
import React from 'react';
import { Box } from '@mui/material';
import { useOutletContext } from 'react-router-dom';

import UnifiedKanbanBoard from '../tasks/UnifiedKanbanBoard';
import { useSectionOperations } from '../../hooks/useSectionOperations';

/**
 * ProjectKanban component - Clean Kanban view using unified system
 */
const ProjectKanban = () => {
  const { project } = useOutletContext();
  
  // Section operations for the unified board
  const {
    createSection,
    updateSection,
    deleteSection,
    reorderSections
  } = useSectionOperations();
  
  // Get team members from project
  const teamMembers = project?.team?.map(member => member.user) || [];
  
  return (
    <Box sx={{ 
      height: '100%', 
      display: 'flex', 
      flexDirection: 'column',
      position: 'relative'
    }}>
      <UnifiedKanbanBoard
        projectId={project?._id}
        teamMembers={teamMembers}
        project={project}
      />
    </Box>
  );
};

export default ProjectKanban;